export function removeFromArray(arr, obj) {
    var index = arr.indexOf(obj);
    if (index !== -1) {
        arr.splice(index, 1);
    }
}
export var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
export { isNil, isFunction, isString, isObject, isArray, mix, each, upperFirst } from '@antv/util';
// æ¯å¦åç´ çç¶å®¹å¨
export function isParent(container, shape) {
    // ææ shape é½æ¯ canvas çå­åç´ 
    if (container.isCanvas()) {
        return true;
    }
    var parent = shape.getParent();
    var isParent = false;
    while (parent) {
        if (parent === container) {
            isParent = true;
            break;
        }
        parent = parent.getParent();
    }
    return isParent;
}
export function isAllowCapture(element) {
    // @ts-ignore
    return element.cfg.visible && element.cfg.capture;
}
//# sourceMappingURL=util.js.map